import React from 'react';
import { styled } from '@mui/material/styles';
import { Grid, Button, Typography, DialogActions, Divider } from '@mui/material';
import BaseDialog from '../../Common/BaseDialog';

const GridContainer = styled(Grid)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

interface ConfirmationDialogProps {
  title: string;
  text: string;
  isOpen: boolean;
  onAccept: () => void;
  onCancel: () => void;
}

export default function ConfirmationDialog({ text, title: dialogTitle, isOpen, onAccept, onCancel }: ConfirmationDialogProps) {

  const DialogContent = () => {
    return (
      <>
        <GridContainer container sx={{ alignItems: 'center' }}>
          <Grid size={12}>
            <Typography>{text}</Typography>
          </Grid>
        </GridContainer>
        <Divider/>
        <DialogActions>
          <Button
            variant='contained'
            color='primary'
            aria-label='ok'
            data-testid="ok-btn"
            onClick={onAccept}
          >
            Yes
          </Button>
          <Button
            variant='contained'
            color='secondary'
            aria-label='cancel'
            data-testid="cancel-btn"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </DialogActions>
      </>
    );
  }

  return (
    <BaseDialog
      open={isOpen}
      header={dialogTitle}
      showCloseButton={false}
      showCloseIcon={false}
      onClose={onCancel}
    >{
      DialogContent()
    }</BaseDialog>
  );
}
